<template>
  <div data-v-c313cd16="" data-v-e5781868="" class="depositUSDT deposit mainContent top50" style="background: #fafafa;">
    <div data-v-c313cd16="" class="content">
      <div data-v-c313cd16="" class="title">
        <a href="javascript:void(0);" @click="$router.go(-1)"
          ><svg data-v-338e1447="" data-v-c313cd16="" aria-hidden="true" class="svg-icon undo">
            <use data-v-338e1447="" xlink:href="#icon-undo"></use></svg
          >存款</a
        >
      </div>
      <div data-v-c313cd16="" class="box">
        <div data-v-c313cd16="" class="sidebar">
          <div data-v-c313cd16="" class="group">
            <p data-v-c313cd16="">充值方式：</p>
            <div data-v-c313cd16="" :class="pay_way == 'bank' ? 'nav active' : 'nav'" @click="changPayway('bank')" v-if="payWayList.card == 1">
              银行卡充值
              <svg data-v-338e1447="" data-v-c313cd16="" aria-hidden="true" class="svg-icon arrowRight">
                <use data-v-338e1447="" xlink:href="#icon-arrowRight"></use>
              </svg>
            </div>
            <div data-v-c313cd16="" :class="pay_way == 'usdt' ? 'nav active' : 'nav'" @click="changPayway('usdt')"  v-if="payWayList.usdt == 1">
              USDT人工充值
              <svg data-v-338e1447="" data-v-c313cd16="" aria-hidden="true" class="svg-icon arrowRight">
                <use data-v-338e1447="" xlink:href="#icon-arrowRight"></use>
              </svg>
            </div>
            <div data-v-c313cd16="" :class="pay_way == 'epayusdt' ? 'nav active' : 'nav'" @click="changPayway('epayusdt')"  v-if="payWayList.epayusdt == 1">
              USDT在线充值
              <svg data-v-338e1447="" data-v-c313cd16="" aria-hidden="true" class="svg-icon arrowRight">
                <use data-v-338e1447="" xlink:href="#icon-arrowRight"></use>
              </svg>
            </div>			
            <div data-v-c313cd16="" :class="pay_way == 'alipay' ? 'nav active' : 'nav'" @click="changPayway('alipay')"  v-if="payWayList.alipay == 1">
              支付宝充值
              <svg data-v-338e1447="" data-v-c313cd16="" aria-hidden="true" class="svg-icon arrowRight">
                <use data-v-338e1447="" xlink:href="#icon-arrowRight"></use>
              </svg>
            </div>
            <div data-v-c313cd16="" :class="pay_way == 'wechat' ? 'nav active' : 'nav'" v-if="payWayList.wechat == 1" @click="changPayway('wechat')">
              微信充值
              <svg data-v-338e1447="" data-v-c313cd16="" aria-hidden="true" class="svg-icon arrowRight">
                <use data-v-338e1447="" xlink:href="#icon-arrowRight"></use>
              </svg>
            </div>
            <div data-v-c313cd16="" :class="pay_way == 'rengong' ? 'nav active' : 'nav'" @click="changPayway('rengong')">
              人工充值
              <svg data-v-338e1447="" data-v-c313cd16="" aria-hidden="true" class="svg-icon arrowRight">
                <use data-v-338e1447="" xlink:href="#icon-arrowRight"></use>
              </svg>
            </div>
          </div>
          <div data-v-2924bd9d="" class="graph">
            <div data-v-2924bd9d="" class="text">
              <p data-v-2924bd9d="">当前汇率: 1USDT≈{{ $store.state.userInfo.usdtrate }}CNY</p>
              <div data-v-2924bd9d="" class="help">
                <svg data-v-338e1447="" data-v-2924bd9d="" aria-hidden="true" class="svg-icon iconHelp"><use data-v-338e1447="" xlink:href="#icon-iconHelp"></use></svg>
                <div data-v-2924bd9d="" class="info">汇率仅供参考</div>
              </div>
            </div>
          </div>
        </div>
        <div data-v-c313cd16="" class="right">
          <!-- USDT充值 -->
          <div data-v-4b991137="" data-v-c313cd16="" class="tabContent" v-if="pay_way == 'usdt'">
            <h3 data-v-4b991137="">USDT人工充币</h3>
            <div data-v-4b991137="" class="block">
              <div data-v-4b991137="" class="steps">
                <div data-v-4b991137="" :class="step == 1 ? 'step active' : 'step'">1.输入金额</div>
                <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon dottedArrow">
                  <use data-v-338e1447="" xlink:href="#icon-dottedArrow"></use>
                </svg>
                <div data-v-4b991137="" :class="step == 2 ? 'step active' : 'step'">2.获取地址</div>
                <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon dottedArrow">
                  <use data-v-338e1447="" xlink:href="#icon-dottedArrow"></use>
                </svg>
                <div data-v-4b991137="" :class="step == 3 ? 'step active' : 'step'">3.等待到账</div>
              </div>
              <div data-v-4b991137="" class="c" v-if="step == 1">
                <form data-v-4b991137="">
                  <div data-v-4b991137="" class="formGroup">
                    <label data-v-4b991137="">充币金额</label>
                    <div data-v-4b991137="" class="inputGroup inputGroupInline">
                      <input data-v-4b991137="" v-model="amount" type="text" placeholder="请输入充值的金额" class="inputNum" />
                      <span data-v-4b991137="" class="currency"> CNY</span>
                    </div>
                    <span data-v-4b991137=""> ≈ {{ amount ? Math.floor((amount / $store.state.userInfo.usdtrate) * 100) / 100 : '0.00' }} USDT &nbsp;&nbsp;&nbsp;&nbsp;参考汇率：{{ $store.state.userInfo.usdtrate }}</span>
                    <div data-v-4b991137="" class="clear"></div>
                    <div data-v-4b991137="" class="message" style="display: none">当前金额可获赠0USDT</div>
                  </div>
                  <div data-v-043ac135="" class="formGroup">
                    <label data-v-043ac135="">钱包协议</label>
                    <ul data-v-043ac135="" class="protocolList">
                      <li data-v-043ac135="" :class="meyXi == 'TRC20' ? 'active' : ''" @click="changMeyXi('TRC20')">TRC20<span data-v-043ac135="">推荐</span></li>
                      <li data-v-043ac135="" :class="meyXi == 'ERC20' ? 'active' : ''" @click="changMeyXi('ERC20')">ERC20</li>
                      <li data-v-043ac135="" class="protocolHelp" @click="showxiyiShow">
                        <svg data-v-338e1447="" data-v-043ac135="" aria-hidden="true" class="svg-icon iconQuestion"><use data-v-338e1447="" xlink:href="#icon-iconQuestion"></use></svg>协议区别
                      </li>
                    </ul>
                  </div>
                  <a data-v-4b991137="" :class="amount ? 'button ' : 'button disabled'" @click="chongBi">获取充币地址</a>
                </form>
              </div>
              <div data-v-4b991137="" class="c" v-if="step == 2">
                <div data-v-4b991137="" class="leftImg">
                  <div data-v-4b991137="" class="bg"></div>
                  <p data-v-4b991137="" class="crc"></p>
                  <p data-v-4b991137="" class="crc2"></p>
                  <div data-v-4b991137="" class="qr">
                    <div data-v-4b991137="">
                      <img :src="payInfo.cardlist.payimg" alt="" />
                    </div>
                    <div data-v-4b991137="" style="display: none"></div>
                  </div>
                  <p data-v-4b991137="" class="protocolTitle">{{ payInfo.info.bank }}协议</p>
                </div>
                <div data-v-4b991137="" class="info info2">
                  <div data-v-4b991137="" class="text">充币金额</div>
                  <h4 data-v-4b991137="">
                    {{ payInfo.info.amount }}CNY <span data-v-4b991137="">预计到账{{ payInfo.info.real_money }} USDT</span>
                  </h4>
                  <p data-v-4b991137="">您可通过数字钱包扫描二维码或复制地址转币完成充值</p>
                  <p data-v-4b991137="">发送您的CNY存款至：</p>
                  <div data-v-4b991137="" class="inputGroup">
                    <input data-v-4b991137="" type="text" placeholder="" :value="payInfo.cardlist.mch_id" disabled="disabled" />
                    <span data-v-4b991137="" class="copy" @click="doCopy(payInfo.cardlist.mch_id)">复制</span>
                  </div>
                  <div data-v-4b991137="" class="groupButton">
                    <a data-v-4b991137="" class="btn buttonBordered" @click="changStep(1)"
                      >重新填写
                      <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg></a
                    ><a data-v-4b991137="" class="btn buttonSolid" @click="changStep(3)"
                      >已完成支付<svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                  <div data-v-4b991137="" class="warningMessage">
                    <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon warning">
                      <use data-v-338e1447="" xlink:href="#icon-warning"></use>
                    </svg>
                    请选择正确的钱包协议类型进行存款，否则资产将无法找回
                  </div>
                </div>
              </div>
              <div data-v-4b991137="" class="c" v-if="step == 3">
                <div data-v-4b991137="" class="leftImg">
                  <div data-v-4b991137="" class="bg"></div>
                  <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon depositClock">
                    <use data-v-338e1447="" xlink:href="#icon-depositClock"></use>
                  </svg>
                </div>
                <div data-v-4b991137="" class="info">
                  <h5 data-v-4b991137="">正在处理您的请求...</h5>
                  <p data-v-4b991137="">通常在5分钟内到账</p>
                  <a data-v-4b991137="" class="btn buttonSolid" @click="$parent.goNav('/fundingRecords')"
                    >查看交易记录<svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon iconArrow">
                      <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                  ></a>
                </div>
              </div>
            </div>
          </div>
          <div data-v-4b991137="" data-v-c313cd16="" class="tabContent" v-if="pay_way == 'epayusdt'">
            <h3 data-v-4b991137="">USDT在线充值充币</h3>
            <div data-v-4b991137="" class="block">
              <div data-v-4b991137="" class="steps">
                <div data-v-4b991137="" :class="step == 1 ? 'step active' : 'step'">1.输入金额</div>
                <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon dottedArrow">
                  <use data-v-338e1447="" xlink:href="#icon-dottedArrow"></use>
                </svg>
                <div data-v-4b991137="" :class="step == 2 ? 'step active' : 'step'">2.跳转支付</div>
                <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon dottedArrow">
                  <use data-v-338e1447="" xlink:href="#icon-dottedArrow"></use>
                </svg>
                <div data-v-4b991137="" :class="step == 3 ? 'step active' : 'step'">3.等待到账</div>
              </div>
              <div data-v-4b991137="" class="c" v-if="step == 1">
                <form data-v-4b991137="">
                  <div data-v-4b991137="" class="formGroup">
                    <label data-v-4b991137="">充币金额</label>
                    <div data-v-4b991137="" class="inputGroup inputGroupInline">
                      <input data-v-4b991137="" v-model="amount" type="text" placeholder="请输入充值的金额" class="inputNum" />
                      <span data-v-4b991137="" class="currency"> CNY</span>
                    </div>
                    <span data-v-4b991137=""> ≈ {{ amount ? Math.floor((amount / $store.state.userInfo.usdtrate) * 100) / 100 : '0.00' }} USDT &nbsp;&nbsp;&nbsp;&nbsp;参考汇率：{{ $store.state.userInfo.usdtrate }}</span>
                    <div data-v-4b991137="" class="clear"></div>
                    <div data-v-4b991137="" class="message" style="display: none">当前金额可获赠0USDT</div>
                  </div>
                  <div data-v-043ac135="" class="formGroup">
                    <label data-v-043ac135="">钱包协议</label>
                    <ul data-v-043ac135="" class="protocolList">
                      <li data-v-043ac135="" :class="meyXi == 'TRC20' ? 'active' : ''" @click="changMeyXi('TRC20')">TRC20<span data-v-043ac135="">推荐</span></li>
                      <li data-v-043ac135="" :class="meyXi == 'ERC20' ? 'active' : ''" @click="changMeyXi('ERC20')">ERC20</li>
                      <li data-v-043ac135="" class="protocolHelp" @click="showxiyiShow">
                        <svg data-v-338e1447="" data-v-043ac135="" aria-hidden="true" class="svg-icon iconQuestion"><use data-v-338e1447="" xlink:href="#icon-iconQuestion"></use></svg>协议区别
                      </li>
                    </ul>
                  </div>
                  <a data-v-4b991137="" :class="amount ? 'button ' : 'button disabled'" @click="chongBi">跳转支付页面</a>
                </form>
              </div>
              <div data-v-4b991137="" class="c" v-if="step == 2">
                <div data-v-4b991137="" class="leftImg">
                  <div data-v-4b991137="" class="bg"></div>
                  <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon depositClock">
                    <use data-v-338e1447="" xlink:href="#icon-depositClock"></use>
                  </svg>
                </div>
                <div data-v-4b991137="" class="info">
                  <h5 data-v-4b991137="">请在新打开的支付窗口完成充值</h5>
                  <p data-v-4b991137="">若支付窗口未弹出，请检查浏览器弹窗设置</p>
                  <a data-v-4b991137="" class="btn buttonBordered" @click="changStep(1)"
                    >重新支付
                    <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon iconArrow">
                      <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                  ></a>
                  <a data-v-4b991137="" class="btn buttonSolid" @click="changStep(3)"
                    >已完成支付<svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon iconArrow">
                      <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                  ></a>
                </div>
              </div>
              <div data-v-4b991137="" class="c" v-if="step == 3">
                <div data-v-4b991137="" class="leftImg">
                  <div data-v-4b991137="" class="bg"></div>
                  <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon depositClock">
                    <use data-v-338e1447="" xlink:href="#icon-depositClock"></use>
                  </svg>
                </div>
                <div data-v-4b991137="" class="info">
                  <h5 data-v-4b991137="">正在处理您的请求...</h5>
                  <p data-v-4b991137="">通常在5分钟内到账</p>
                  <a data-v-4b991137="" class="btn buttonSolid" @click="$parent.goNav('/fundingRecords')"
                    >查看交易记录<svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon iconArrow">
                      <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                  ></a>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 银行卡充值 -->
          <div data-v-4b991137="" data-v-c313cd16="" class="tabContent" v-if="pay_way == 'bank'">
            <h3 data-v-4b991137="">銀行卡充币</h3>
            <div data-v-4b991137="" class="block">
              <div data-v-4b991137="" class="steps">
                <div data-v-4b991137="" :class="step == 1 ? 'step active' : 'step'">1.输入金额</div>
                <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon dottedArrow">
                  <use data-v-338e1447="" xlink:href="#icon-dottedArrow"></use>
                </svg>
                <div data-v-4b991137="" :class="step == 2 ? 'step active' : 'step'">2.等待到账</div>
              </div>
              <div data-v-4b991137="" class="c" v-if="step == 1">
                <div class="JoiHTIGs">
                  <div class="_1lgxzaTd VnPYo1MB _3jiVkBQ9" v-for="(item, index) in cardLis" :key="index">
                    <p style="font-size: 10px; line-height: 1; color: #fff; line-height: 1.5">收款银行：{{ item.bank_data.bank_name }}</p>
                    <p style="font-size: 10px; line-height: 1; color: #fff; line-height: 1.5">账号：{{ item.bank_no }} <img @click="doCopy(item.bank_no)" style="width: 20px; float: right" src="/static/image/clongicon.png" alt="" /></p>
                    <p style="font-size: 10px; line-height: 1; color: #fff; line-height: 1.5">户名：{{ item.bank_owner }} <img @click="doCopy(item.bank_owner)" style="width: 20px; float: right" src="/static/image/clongicon.png" alt="" /></p>
                    <p style="font-size: 10px; line-height: 1.2; color: #fff; line-height: 1.5">银行地址：{{ item.bank_address }}</p>
                  </div>
                </div>

                <form data-v-4b991137="">
                  <div data-v-4b991137="" class="formGroup">
                    <label data-v-4b991137="">汇款姓名</label>
                    <div data-v-4b991137="" class="inputGroup inputGroupInline">
                      <input data-v-4b991137="" v-model="bankBox.bank_owner" type="text" placeholder="请输入汇款姓名" class="inputNum" />
                    </div>
                  </div>
                  <div data-v-4b991137="" class="formGroup">
                    <label data-v-4b991137="">银行类型</label>
                    <div data-v-4b991137="" class="inputGroup inputGroupInline">
                      <el-select v-model="bankBox.bank" placeholder="请选择银行类型" class="inputNum" size="mini" style="width: 100%;background: #fafafa;">
                        <el-option v-for="(item, index) in banklist" :key="index" :label="item.bank_name" :value="item.bank_name"> </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div data-v-4b991137="" class="formGroup">
                    <label data-v-4b991137="">卡号</label>
                    <div data-v-4b991137="" class="inputGroup inputGroupInline">
                      <input data-v-4b991137="" v-model="bankBox.bank_no" type="text" placeholder="请输入卡号" class="inputNum" />
                    </div>
                  </div>
                  <div data-v-4b991137="" class="formGroup">
                    <label data-v-4b991137="">开户行</label>
                    <div data-v-4b991137="" class="inputGroup inputGroupInline">
                      <input data-v-4b991137="" v-model="bankBox.bank_address" type="text" placeholder="请输入开户行" class="inputNum" />
                    </div>
                  </div>
                  <div data-v-4b991137="" class="formGroup">
                    <label data-v-4b991137="">充币金额</label>
                    <div data-v-4b991137="" class="inputGroup inputGroupInline">
                      <input data-v-4b991137="" v-model="amount" type="text" placeholder="请输入充值金额" class="inputNum" />
                      <span data-v-4b991137="" class="currency">CNY</span>
                    </div>
                  </div>
                  <a data-v-4b991137="" :class="amount ? 'button ' : 'button disabled'" @click="chongBi">立即充值</a>
                </form>
              </div>

              <div data-v-4b991137="" class="c" v-if="step == 2">
                <div data-v-4b991137="" class="leftImg">
                  <div data-v-4b991137="" class="bg"></div>
                  <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon depositClock">
                    <use data-v-338e1447="" xlink:href="#icon-depositClock"></use>
                  </svg>
                </div>
                <div data-v-4b991137="" class="info">
                  <h5 data-v-4b991137="">正在处理您的请求...</h5>
                  <p data-v-4b991137="">通常在5分钟内到账</p>
                  <a data-v-4b991137="" class="btn buttonSolid" @click="$parent.goNav('/fundingRecords')"
                    >查看交易记录<svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon iconArrow">
                      <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                  ></a>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 支付宝充值 -->
          <div data-v-4b991137="" data-v-c313cd16="" class="tabContent" v-if="pay_way == 'alipay'">
            <h3 data-v-4b991137="">支付宝充币</h3>
            <div data-v-4b991137="" class="block">
              <div data-v-4b991137="" class="steps">
                <div data-v-4b991137="" :class="step == 1 ? 'step active' : 'step'">1.输入金额</div>
                <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon dottedArrow">
                  <use data-v-338e1447="" xlink:href="#icon-dottedArrow"></use>
                </svg>
                <div data-v-4b991137="" :class="step == 2 ? 'step active' : 'step'">2.获取地址</div>
                <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon dottedArrow">
                  <use data-v-338e1447="" xlink:href="#icon-dottedArrow"></use>
                </svg>
                <div data-v-4b991137="" :class="step == 3 ? 'step active' : 'step'">3.等待到账</div>
              </div>
              <div data-v-4b991137="" class="c" v-if="step == 1">
                <form data-v-4b991137="">
                  <div data-v-97997370="" class="inlineGroup">
                    <label data-v-97997370="">支付方式</label>
                    <div data-v-97997370="" class="list">
                      <div data-v-97997370="" class="item active">
                        <i data-v-97997370="" class="icon icon-ali-pay"></i>
                        <p data-v-97997370="">支付宝扫码</p>
                        <div data-v-97997370="" class="recommend"></div>
                      </div>
                    </div>
                  </div>
                  <div data-v-4b991137="" class="formGroup">
                    <label data-v-4b991137="">充币金额</label>
                    <div data-v-4b991137="" class="inputGroup inputGroupInline">
                      <input data-v-4b991137="" v-model="amount" type="text" placeholder="请输入充值的金额" class="inputNum" />
                      <span data-v-4b991137="" class="currency">CNY</span>
                    </div>
                    <div data-v-4b991137="" class="clear"></div>
                    <div data-v-4b991137="" class="message" style="display: none">当前金额可获赠0USDT</div>
                  </div>
                  <a data-v-4b991137="" :class="amount ? 'button ' : 'button disabled'" @click="chongBi">获取充币地址</a>
                </form>
              </div>
              <div data-v-4b991137="" class="c" v-if="step == 2">
                <div data-v-4b991137="" class="leftImg">
                  <div data-v-4b991137="" class="bg"></div>
                  <p data-v-4b991137="" class="crc"></p>
                  <p data-v-4b991137="" class="crc2"></p>
                  <div data-v-4b991137="" class="qr">
                    <div data-v-4b991137=""><img :src="payInfo.cardlist.payimg" alt="" /></div>
                    <div data-v-4b991137="" style="display: none"></div>
                  </div>
                  <p data-v-4b991137="" class="protocolTitle">{{ payInfo.cardlist.content }}</p>
                </div>
                <div data-v-4b991137="" class="info info2">
                  <div data-v-4b991137="" class="text">充币金额</div>
                  <h4 data-v-4b991137="">{{ payInfo.info.amount }}CNY <span data-v-4b991137=""></span></h4>
                  <p data-v-4b991137="">扫描二维码完成充值</p>
                  <div data-v-4b991137="" class="groupButton">
                    <a data-v-4b991137="" class="btn buttonBordered" @click="changStep(1)"
                      >重新填写
                      <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg></a
                    ><a data-v-4b991137="" class="btn buttonSolid" @click="changStep(3)"
                      >已完成支付<svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                  <div data-v-4b991137="" class="warningMessage">
                    <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon warning">
                      <use data-v-338e1447="" xlink:href="#icon-warning"></use>
                    </svg>
                    请使用支付宝扫码充值！
                  </div>
                </div>
              </div>
              <div data-v-4b991137="" class="c" v-if="step == 3">
                <div data-v-4b991137="" class="leftImg">
                  <div data-v-4b991137="" class="bg"></div>
                  <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon depositClock">
                    <use data-v-338e1447="" xlink:href="#icon-depositClock"></use>
                  </svg>
                </div>
                <div data-v-4b991137="" class="info">
                  <h5 data-v-4b991137="">正在处理您的请求...</h5>
                  <p data-v-4b991137="">通常在5分钟内到账</p>
                  <a data-v-4b991137="" class="btn buttonSolid" @click="$parent.goNav('/fundingRecords')"
                    >查看交易记录<svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon iconArrow">
                      <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                  ></a>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 微信充值 -->
          <div data-v-4b991137="" data-v-c313cd16="" class="tabContent" v-if="pay_way == 'wechat'">
            <h3 data-v-4b991137="">微信充币</h3>
            <div data-v-4b991137="" class="block">
              <div data-v-4b991137="" class="steps">
                <div data-v-4b991137="" :class="step == 1 ? 'step active' : 'step'">1.输入金额</div>
                <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon dottedArrow">
                  <use data-v-338e1447="" xlink:href="#icon-dottedArrow"></use>
                </svg>
                <div data-v-4b991137="" :class="step == 2 ? 'step active' : 'step'">2.获取地址</div>
                <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon dottedArrow">
                  <use data-v-338e1447="" xlink:href="#icon-dottedArrow"></use>
                </svg>
                <div data-v-4b991137="" :class="step == 3 ? 'step active' : 'step'">3.等待到账</div>
              </div>
              <div data-v-4b991137="" class="c" v-if="step == 1">
                <form data-v-4b991137="">
                  <div data-v-97997370="" class="inlineGroup">
                    <label data-v-97997370="">支付方式</label>
                    <div data-v-97997370="" class="list">
                      <div data-v-97997370="" class="item active">
                        <i data-v-97997370="" class="icon icon-ali-pay weixin"></i>
                        <p data-v-97997370="">微信扫码</p>
                        <div data-v-97997370="" class="recommend"></div>
                      </div>
                    </div>
                  </div>
                  <div data-v-4b991137="" class="formGroup">
                    <label data-v-4b991137="">充币金额</label>
                    <div data-v-4b991137="" class="inputGroup inputGroupInline">
                      <input data-v-4b991137="" v-model="amount" type="text" placeholder="请输入充值的金额" class="inputNum" />
                      <span data-v-4b991137="" class="currency">CNY</span>
                    </div>
                    <div data-v-4b991137="" class="clear"></div>
                    <div data-v-4b991137="" class="message" style="display: none">当前金额可获赠0USDT</div>
                  </div>
                  <a data-v-4b991137="" :class="amount ? 'button ' : 'button disabled'" @click="chongBi">获取充币地址</a>
                </form>
              </div>
              <div data-v-4b991137="" class="c" v-if="step == 2">
                <div data-v-4b991137="" class="leftImg">
                  <div data-v-4b991137="" class="bg"></div>
                  <p data-v-4b991137="" class="crc"></p>
                  <p data-v-4b991137="" class="crc2"></p>
                  <div data-v-4b991137="" class="qr">
                    <div data-v-4b991137=""><img :src="payInfo.cardlist.payimg" alt="" /></div>
                    <div data-v-4b991137="" style="display: none"></div>
                  </div>
                  <p data-v-4b991137="" class="protocolTitle">{{ payInfo.cardlist.content }}</p>
                </div>
                <div data-v-4b991137="" class="info info2">
                  <div data-v-4b991137="" class="text">充币金额</div>
                  <h4 data-v-4b991137="">{{ payInfo.info.amount }}CNY <span data-v-4b991137=""></span></h4>
                  <p data-v-4b991137="">扫描二维码完成充值</p>
                  <div data-v-4b991137="" class="groupButton">
                    <a data-v-4b991137="" class="btn buttonBordered" @click="changStep(1)"
                      >重新填写
                      <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg></a
                    ><a data-v-4b991137="" class="btn buttonSolid" @click="changStep(3)"
                      >已完成支付<svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                  <div data-v-4b991137="" class="warningMessage">
                    <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon warning">
                      <use data-v-338e1447="" xlink:href="#icon-warning"></use>
                    </svg>
                    请使用微信扫码充值！
                  </div>
                </div>
              </div>
              <div data-v-4b991137="" class="c" v-if="step == 3">
                <div data-v-4b991137="" class="leftImg">
                  <div data-v-4b991137="" class="bg"></div>
                  <svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon depositClock">
                    <use data-v-338e1447="" xlink:href="#icon-depositClock"></use>
                  </svg>
                </div>
                <div data-v-4b991137="" class="info">
                  <h5 data-v-4b991137="">正在处理您的请求...</h5>
                  <p data-v-4b991137="">通常在5分钟内到账</p>
                  <a data-v-4b991137="" class="btn buttonSolid" @click="$parent.goNav('/fundingRecords')"
                    >查看交易记录<svg data-v-338e1447="" data-v-4b991137="" aria-hidden="true" class="svg-icon iconArrow">
                      <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                  ></a>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 人工充值 -->
          <div data-v-4b991137="" data-v-c313cd16="" class="tabContent" v-if="pay_way == 'rengong'">
            <h3 data-v-4b991137="">人工充值</h3>
            <div data-v-4b991137="" class="block">
              <div data-v-4b991137="" class="c">
                <form data-v-4b991137="">
                  <div data-v-4b991137="" class="formGroup">
                    <label data-v-4b991137="">温馨提示：若其他支付方式失败，建议您使用人工充值功能，由专人客服引导您进行充值。</label>
                  </div>
                  <a data-v-4b991137="" class="button" @click="$parent.openKefu()">联系客服</a>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-v-c313cd16="" class="backdrop" style="display: none">
      <div data-v-c313cd16="" class="popup popWarning">
        <div data-v-c313cd16="" class="popHead">
          提示
          <a data-v-c313cd16="" class="popClose"
            ><svg data-v-338e1447="" data-v-c313cd16="" aria-hidden="true" class="svg-icon iconClose">
              <use data-v-338e1447="" xlink:href="#icon-iconClose"></use></svg
          ></a>
        </div>
        <div data-v-c313cd16="" class="popContent">
          <svg data-v-338e1447="" data-v-c313cd16="" aria-hidden="true" class="svg-icon iconPopWarning">
            <use data-v-338e1447="" xlink:href="#icon-iconPopWarning"></use>
          </svg>
          <p data-v-c313cd16="">存款人姓名与绑定姓名不符，请联系客服咨询</p>
          <a data-v-c313cd16="" class="popButton buttonSolid">联系客服</a>
        </div>
      </div>
    </div>
    <div data-v-c313cd16="" class="backdrop" style="display: none">
      <div data-v-c313cd16="" class="popup popWarning">
        <div data-v-c313cd16="" class="popHead">
          提示
          <a data-v-c313cd16="" class="popClose"
            ><svg data-v-338e1447="" data-v-c313cd16="" aria-hidden="true" class="svg-icon iconClose">
              <use data-v-338e1447="" xlink:href="#icon-iconClose"></use></svg
          ></a>
        </div>
        <div data-v-c313cd16="" class="popContent">
          <svg data-v-338e1447="" data-v-c313cd16="" aria-hidden="true" class="svg-icon iconPopWarning">
            <use data-v-338e1447="" xlink:href="#icon-iconPopWarning"></use>
          </svg>
          <p data-v-c313cd16="">尊敬的贵宾，请按照页面展示的信息通过支付宝、网银或手机(同行或跨行)转账、ATM机现金等方式汇款，如汇款成功及信息匹配正确，系统将自动添加您的存款。</p>
          <a data-v-c313cd16="" class="popButton buttonSolid">确定</a>
        </div>
      </div>
    </div>
    <div v-if="xiyiShow" data-v-808c9bb4="" data-v-043ac135="" class="backdrop">
      <div data-v-808c9bb4="" class="pop-step">
        <div data-v-808c9bb4="" class="pop-head">协议区别 <a data-v-808c9bb4="" class="pop-close" @click="showxiyiShow"></a></div>
        <div data-v-808c9bb4="" class="pop-c"><img data-v-808c9bb4="" src="/static/image/xieyi.png" /></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'deposit',
  data() {
    return {
      pay_way: '',
      amount: null, 
      meyXi: 'TRC20', 
      xiyiShow: false,
      bankBox: {},
      step: 1,
      payInfo: {},
      cardLis: [],
      banklist: [],
      payWayList: {},
      baseURL: ''
    };
  },
  created() {
    const that = this;
    that.getBanklist();
    that.getcard();
    that.getPayWay();
    that.baseURL = sessionStorage.getItem('baseURL') || '';
  },
  methods: {
    // 获取支付方式列表
    getPayWay() {
      const that = this;
      that.$parent.showLoading();

      that.$apiFun
        .get('/api/get_pay_way', {})
        .then(res => {
          if (res.code == 200) {
            that.payWayList = res.data;
            that.payWayList.rengong = 1;
            const obj = that.payWayList;
            for(const i in obj){
              if(obj[i] == 1){
                that.pay_way = i == 'card'? 'bank' : i ;
                return;
              }
            }
          }
          that.$parent.hideLoading();
        })
        .catch(() => {
          that.$parent.hideLoading();
        });
    },
    // 获取银行列表
    getBanklist() {
      const that = this;
      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(() => {
          that.$parent.hideLoading();
        });
    },
    // 获取收款银行卡信息
    getcard() {
      const that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/getpaybank', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            if (res.data.length > 0) {
              that.cardLis = res.data;
            } else {
              that.cardLis.push(res.data);
            }
          }
          that.$parent.hideLoading();
        });
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();

    
      document.execCommand('copy');

      this.$parent.showTost(1, '复制成功！');
    },
    showxiyiShow() {
      this.xiyiShow = !this.xiyiShow;
    },
    changMeyXi(val) {
      let that = this;
      this.meyXi = val;
    },
    chongBi() {
      let that = this;
      let info = {};
      if (that.pay_way == 'rengong') {
        that.openKefu();
        return;
      }
      if (that.pay_way == 'bank') {
        info = {
          paytype: that.pay_way,
          amount: that.amount * 1,
          bank: that.bankBox.bank,
          bank_address: that.bankBox.bank_address,
          bank_no: that.bankBox.bank_no,
          bank_owner: that.bankBox.bank_owner,
        };
        console.log(info);
        if (!info.bank_owner) {
          that.$parent.showTost(0, '请输入存款人姓名');
          return;
        }
        if (!info.bank) {
          that.$parent.showTost(0, '请输入银行类型');
          return;
        }

        if (!info.bank_no) {
          that.$parent.showTost(0, '请输入银行卡号');
          return;
        }
        if (!info.bank_address) {
          that.$parent.showTost(0, '请输入银行开户行地址');
          return;
        }
      } else {
        info = {
          paytype: that.pay_way,
          amount: that.amount * 1,
        };
      }
      if (that.pay_way == 'usdt' || that.pay_way == 'epayusdt') {
        info.catepay = that.meyXi;
      }

      if (info.amount <= 0) {
        that.$parent.showTost(0, '请输入正确金额');
        return;
      }
      that.$parent.showLoading();
      info.paytype = info.paytype == 'wechat' ? 'wxpay' : info.paytype ;
      const apiUrl = that.pay_way === 'epayusdt' ? '/api/epay_recharge' : '/api/recharge';
      that.$apiFun
        .post(apiUrl, info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
            that.$parent.hideLoading();
            return;
          }
          if (res.code == 200) {
            that.amount = null;
            if (that.pay_way == 'epayusdt') {
              that.bankBox = {};
              that.amount = null;
              const payUrl = res.data.pay_url || res.message;
              window.open(payUrl, '_blank');
              that.step = 2;
              that.$parent.hideLoading();
              return;
            }
            if (that.pay_way == 'bank') {
              that.bankBox = {};
              that.amount = null;
              that.step = 2;
              that.$parent.hideLoading();
              return;
            }
            that.bankBox = {};
            that.amount = null;
            that.getpayinfo(res.message);
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    changStep(val) {
      this.step = val;
    },
    getpayinfo(deposit_no) {
      let that = this;
      that.$apiFun.post('/api/payinfo', { deposit_no }).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.payInfo = res.data;
          that.step = 2;
        }

        that.$parent.hideLoading();
      });
    },
    changPayway(val) {
      let that = this;
      if (val == that.pay_way) {
        return;
      }
      that.pay_way = val;
      that.bankBox = {};
      that.step = 1;
      that.payInfo = {};
      that.amount = null;
    },
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    let that = this;
    var mySwiper = new Swiper('.bannerSwiper .swiper', {
      slidesPerView: 'auto',
      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.bannerSwiper .swiper-button-next',
        prevEl: '.bannerSwiper .swiper-button-prev',
      },
    });
    var swiperList = new Swiper('.box .swiper-img', {
      navigation: {
        nextEl: '.swiper-img .swiper-button-next',
        prevEl: '.swiper-img .swiper-button-prev',
      },
    });
    var swiper = new Swiper('.k8BrandWay .c .timeline .swiper', {
      navigation: {
        nextEl: '.k8BrandWay .c .timeline .tool.next',
        prevEl: '.k8BrandWay .c .timeline .tool.prev',
      },
    });
    $('.k8BrandWay .c .timeline .swiper .swiper-slide .swiper-content .items .item').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      var u = $(this).index();
      var b = ((u + 1) / 7) * 100;
      console.log(b);
      $(this)
        .parents('.swiper-slide')
        .find('.swiper-content .line .activeState')
        .css('width', b + '%');
      var i = $(this).parents('.swiper-slide').index();
      if (i > 1) {
        for (var t = 0; t < i; t++) {
          if (t > 1) {
            $('.k8BrandWay .c .timeline .swiper .swiper-slide').eq(t).find('.swiper-content .line .activeState').css('width', '100%');
          }
        }
      }
      var m = i * 7;
      var o = m + u;
      swiperList.slideTo(o, 1000, false);
    });
    $('.table table tr').click(function () {
      $('.table table tr').removeClass('active');
      $(this).addClass('active');
      var username = $(this).find('td').eq(1).text();
      var amount = $(this).find('td').eq(2).text();
      $('.profit .user-name').text('会员' + username);
      $('.profit .amount h1').text(amount.replace('元', ''));
    });
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-d26b63dc.5f1b35c1.css';
@import '../../../static/css/chunk-9a40ea92.88a1372b.css';
.deposit .title[data-v-c313cd16][data-v-39222142]{
	color: #000;
}
.deposit .box[data-v-c313cd16][data-v-39222142] {
  background: #fafafa;
}
.deposit .box .sidebar .group .nav[data-v-c313cd16][data-v-39222142]{
    background: #fafafa;	
	border: 1px solid #ccc;
	border-radius: 10px;
	color: #ffcb4c;
}
.deposit .box .right h3[data-v-4b991137][data-v-39222142]{
	color: #000;
}
.deposit .box .right .block[data-v-4b991137][data-v-39222142]{
	background: #fafafa;
	border: 1px solid #ccc;
	border-radius: 10px;
}
.deposit .box .right .block .steps .step[data-v-4b991137][data-v-39222142]{
	background: #999;
}
.deposit .box .right .block .inlineGroup label[data-v-97997370][data-v-39222142],
.deposit .box .right .block .c .info h5[data-v-4b991137][data-v-39222142],
.deposit .box .right .block .c .info h4[data-v-4b991137][data-v-39222142],
.deposit.depositUSDT .box .right .block .c .text[data-v-4b991137][data-v-39222142],
.deposit .box .right .block .c .formGroup label[data-v-4b991137][data-v-39222142]{
	color: #000;
}
.deposit .box .sidebar .graph[data-v-2924bd9d] {
  text-align: center;
  margin-top: 0.3rem;
}
.deposit .box .sidebar .graph img[data-v-2924bd9d] {
  display: block;
  margin-bottom: 0.1rem;
  width: 100%;
}
.deposit .box .sidebar .graph .text p[data-v-2924bd9d] {
  font-size: 0.14rem;
  color: #8e8e99;
  display: inline-block;
}
.deposit .box .sidebar .graph .text .help[data-v-2924bd9d] {
  display: inline-block;
  position: relative;
  width: 0.14rem;
  height: 0.14rem;
  margin-left: 0.05rem;
}
.deposit .box .sidebar .graph .text .help .iconHelp[data-v-2924bd9d] {
  width: 0.14rem;
  height: 0.14rem;
  cursor: pointer;
}
.deposit .box .sidebar .graph .text .help:hover .info[data-v-2924bd9d] {
  display: block;
}
.deposit .box .sidebar .graph .text .help .info[data-v-2924bd9d] {
  background: #fff;
  width: 1.3rem;
  height: 0.4rem;
  border-radius: 0.04rem;
  text-align: center;
  line-height: 0.4rem;
  font-size: 0.14rem;
  color: #333;
  position: absolute;
  top: 0.27rem;
  left: -0.57rem;
  display: none;
}
.deposit .box .right .block .c .formGroup label[data-v-043ac135] {
  display: block;
  font-size: 0.16rem;
  color: #fff;
  margin-bottom: 0.12rem;
  padding-left: 0.12rem;
  position: relative;
  line-height: 0.15rem;
}
.deposit .box .right .block .c .formGroup .protocolList[data-v-043ac135] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.deposit .box .right .block .c .formGroup .protocolList li.active[data-v-043ac135] {
  background: #202126;
  border: 1.5px solid #a5863b;
  border-radius: 0.04rem;
  color: #ffcb4c;
}
.deposit .box .right .block .c .formGroup .inputGroup input.inputNum[data-v-4b991137][data-v-39222142]{
	color: #000;
}
.deposit .box .right .block .c .formGroup .protocolList li[data-v-043ac135] {
  width: 1.16rem;
  height: 0.4rem;
  background: #2c2e35;
  border-radius: 0.04rem;
  font-family: PingFangSC-Regular;
  font-size: 0.16rem;
  color: #fff;
  letter-spacing: 0;
  line-height: 0.16rem;
  font-weight: 400;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-right: 0.1rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
}
.deposit .box .right .block .c .formGroup .protocolList li.active span[data-v-043ac135] {
  top: -0.01rem;
}

.deposit .box .right .block .c .formGroup .protocolList li span[data-v-043ac135] {
  position: absolute;
  height: 0.14rem;
  line-height: 0.14rem;
  text-align: center;
  top: 0;
  right: 0;
  background-image: -webkit-gradient(linear, right top, left top, color-stop(1%, #ff453e), to(#ff8e08));
  background-image: linear-gradient(270deg, #ff453e 1%, #ff8e08);
  border-radius: 0 0.04rem 0 0.04rem;
  font-family: PingFangSC-Medium;
  font-size: 0.1rem;
  color: #fff;
  letter-spacing: 0;
  font-weight: 500;
  padding: 0 0.04rem;
}
.deposit .box .right .block .c .formGroup span[data-v-043ac135] {
  font-size: 0.14rem;
  color: #8e8e99;
  display: inline-block;
  line-height: 0.4rem;
}
.deposit .box .right .block .c .formGroup .protocolList li.protocolHelp[data-v-043ac135] {
  border: none;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: start;
  font-family: PingFangSC-Regular;
  font-size: 0.14rem;
  color: #ffcb4c;
  letter-spacing: 0;
  background: #15161a;
  font-weight: 400;
}
.deposit .box .right .block .c .formGroup .protocolList li[data-v-043ac135] {
  width: 1.16rem;
  height: 0.4rem;
  background: #2c2e35;
  border-radius: 0.04rem;
  font-family: PingFangSC-Regular;
  font-size: 0.16rem;
  color: #fff;
  letter-spacing: 0;
  line-height: 0.16rem;
  font-weight: 400;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-right: 0.1rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
}
.deposit .box .right .block .c .formGroup .protocolList li.protocolHelp .iconQuestion[data-v-043ac135] {
  width: 14px;
  height: 14px;
  margin-right: 0.05rem;
}

.svg-icon {
  width: 15px !important;
  height: 15px !important;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.deposit .box .right .block .c .formGroup .protocolList li.protocolHelp[data-v-043ac135] {
  border: none;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: start;
  font-family: PingFangSC-Regular;
  font-size: 0.14rem;
  color: #ffcb4c;
  letter-spacing: 0;
  background: #15161a;
  font-weight: 400;
}
.deposit .backdrop[data-v-043ac135] {
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
\.backdrop .pop-step .pop-head[data-v-808c9bb4] {
  height: 0.6rem;
  background: #fafafa;
  position: relative;
  text-align: center;
  line-height: 0.6rem;
  font-size: 0.2rem;
  color: #333;
  border-top-left-radius: 0.04rem;
  border-top-right-radius: 0.04rem;
  font-weight: 700;
}
.backdrop .pop-step .pop-head[data-v-808c9bb4] {
  height: 0.6rem;
  background: #fafafa;
  position: relative;
  text-align: center;
  line-height: 0.6rem;
  font-size: 0.2rem;
  color: #333;
  border-top-left-radius: 0.04rem;
  border-top-right-radius: 0.04rem;
  font-weight: 700;
}
.backdrop .pop-step .pop-c img[data-v-808c9bb4] {
  width: 100%;
  height: 100%;
}

.backdrop .pop-step .pop-c img[data-v-808c9bb4] {
  width: 100%;
  height: 100%;
}
.backdrop .pop-step[data-v-808c9bb4] {
  width: 8rem;
  height: 8.12rem;
  background: #fff;
  border-radius: 0.08rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.backdrop .pop-step .pop-head .pop-close[data-v-808c9bb4] {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAAEEfUpiAAAAAXNSR0IArs4c6QAAAsBJREFUWAm1VrtuU0EQ9UbYkptIBDoaqC1ZSmKJliIpqICSH+DbKJAgDRIIegpfW7LkP4ASUCpbbsyc0ZzV3n3cV8KVkrk7M+fM2dnH9aiqqnej+Fkul0f4aDWeHdScSNtut2ea3mPA/ITM+OB3TIKFYzqdPtrtdr8Xi4XGTphABbPZ7A99ahHIlUBQ/fLvSw0RDCR2ixKP5WUV+PUV6Mlk8pSDKkxCcLPZPETQz0KclY3PBXk2n8//Kjr8B2TIhJifJoJAii9J0umwJlAoRyZHZFwTSZLrkPBRXl7L31raeyG29UFzsRxIjGcJgiJRCGQnPAHLmrQaUQ7I/ISAgYBIXazIOK1vMx2wqCiG/dBtcDgcvoc5fK8paJIaKKr1SAmagKxEGxM5Odo/j8fjk9IcCYwtibAPbuWYPUtOUoyIxoL76pz7gCaeYlNY46K0/FDAaOy1KH95Yht81JXEwOdCsJKd+0abiIMgy6SXAW6N0nQi8CX0+WVsI8mBawQYlEhK4IQgRyK9+SZ+zlllI4+PnwIdsKES86NhCRix7Fmwy2Nt4JE09prvsc0ShHMGoGmJE4IQDNlt+6TWgxhMuWFP4n3iCUrgNhIlaAM3keA04mAU15lg2ng6aGJnMEiwxGzsfr/f+AvFKqylSVelw2Q5g43dfNzZ8lVyv5xNCU5ewihwr0LiwjaDlXTiyu+C/yGkqTA/1V6AqeI5vlNHuhRmvUQAA0M60qcw6xQFMKGLkCGFyd8qgIklIRbHUeSjm4trTGfJdhZAgoIQhHsVJl9yGzOQs2i1/UYKjyxTLxBDDh1dbKcONK0xikjhwaemUUBT4XiNC0vTeqFlBfQpHLe5r5CagLsUHipEBdxn4b5C8D3+JKBXAXDQcQrw2dfC0tw8kE/iZ/mV/ELsj/F4/DbeXFm2AU7jvTQh74XiOWr/A6+/f6dch5YFAAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 100% 100%;
  width: 0.16rem;
  height: 0.16rem;
  position: absolute;
  top: 0.2rem;
  right: 0.2rem;
}
.backdrop .pop-step .pop-c[data-v-808c9bb4] {
  width: 100%;
  height: 7.52rem;
  padding: 0.2rem;
  border-radius: 0 0 0.04rem 0.04rem;
}
.deposit .box .right .block .c .leftImg .svg-icon[data-v-39222142] {
  width: 0.92rem !important;
  height: 0.92rem !important;
}
.JoiHTIGs {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
._1lgxzaTd[data-v-4c5c1c3e] {
  width: 243px;
}
.JoiHTIGs ._3jiVkBQ9 {
  margin-right: 20px;
  margin-bottom: 20px;
}
._1lgxzaTd.VnPYo1MB {
  cursor: pointer;
}
._1lgxzaTd.VnPYo1MB {
  cursor: pointer;
}

._1lgxzaTd {
  width: 224px;
  height: 120px;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
  padding: 12px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  // background-image: url(/static/image/img_cardusdt1-81b6.png);
  background-image: url(/static/image/bg2.c14d2591.png);
}
.deposit .box .right .block .inlineGroup[data-v-97997370] {
  margin-bottom: 0.2rem;
}
.deposit .box .right .block .inlineGroup .list .item.active[data-v-97997370],
.deposit .box .right .block .inlineGroup .list .item[data-v-97997370]:hover {
  background: #202126;
  border: 1px solid #a5863b;
}

.deposit .box .right .block .inlineGroup .list .item[data-v-97997370] {
  position: relative;
  display: inline-block;
  width: 1.4rem;
  height: 0.8rem;
  background: #2c2e35;
  border-radius: 0.04rem;
  text-align: center;
  padding: 0.13rem 0;
  margin: 0 0.1rem 0.1rem 0;
  cursor: pointer;
  border: 1px solid transparent;
  -webkit-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
.deposit .box .right .block .inlineGroup .list .item .icon.icon-ali-pay[data-v-97997370] {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAFMN540AAAABGdBTUEAALGPC/xhBQAABLJJREFUSA2tV19oHEUY/31zm9KknrkLqQpaKUVUfPClhSqIVlJBq7WN5g6NqBQpWvuiglC06IOCIkj0ISZarUJF5RKtIOKDloqoWKGIBhTFoojiQyB7lTZpvOyOv5m53Zu9ZGNzdGBnvv/fzPfNfDMrMK02o+3ITjmkcAuCrgsNUTlO/CDK5820CNXyIKbDhiEIJsIQWpesZLVPAofQhmmecWCiPmoIVJk5Td4UNDbTwqGsDaOmZBCxPmxA01TqAJgjPkfmO6Azy7UCCQR0E+wmsweHw/VWqLu8xklmZtPSIDQmqNWHgHgiQzaIyBGGwWN4fjmvgcBpNBdskQSOPqHZNLxm5mzyMbsbAL3WaYqMQPQJDPWNWn5TwQRlB+1/aIk9qg+z8R9cTtHgzqwqXIM4miX+gxVqds5sHH3jExM4f52JxDJjNg7tgiYuJnE5rRmnDPfnDCZyimFxNJEyF39Bwm9TlkPcE0e4fy6jwLCNcRQDlXKB6Yq9mFt9t4uVPOas6Xu5fd6i9f38NjCYod0lRtG0IOhn/6WF2SUZPI0etQ5z+jt6vYReXkWltBdHdYDp+hlOu5AoQBWGMdT7rsFNEj+jl4GUuQLA7dmVGBCpQ8tuVEuTybRX4C8RVRUXsAT3R1W42QbLp/mw6AP5ygJbQ3z5DMwq4uVZpnnw70sFougXByeHi5joInRcS2Q8Zb2WR3aMaZlvMiscp4DopUSYabwihQlkAyYyz7S5DeFLmbJSM7kOF3yy59kUKHmKB+Ek4ngLhYadoPxuR6kfoOdMc8qiHmfuvuB6niQ3ZAV+DncU77GSR/VqO2q9K6NJxEVb9L9c2zGu93ZO+34sNKbsIZic2Y4bhduTzR5PtYdbN/XvlLVeZwWy3VcsSB9x++7i97JlDZXGecKUy78aaAYsuBIS7eaaHmUIT0Crbaj2/kqlZziT/alNwTH0l6/jbGzgWtEWGcWa0hOIsID5+l08mm+kSu2AzYq6vqXcLvB/uKvl4MbooFXKW5Nr5BWq7+nARCcqYwz4w50VEpNqzbi6xmx7VepspmLD1Un1UmozquVV9lPgvbrC1rpWFyn+Q4oJf07r+jtlxAErRuP5FPcBkdXcno/4pAT2z3JCM+P5/Pb5hCzc+ID4n5amFi5HnCOr08OXVSe2/LYOuq5iPfhpkdbZEGrh68z9A3miyzvO01qafht3q3ng8OkXmkfO5xbO6RaHWuRFBHgWg+V6jg4Nn7qIJWcLdLSdxWwbnbyASuJ05lLqfZqr22R4juU4NpSuxW/1N9HQIatmjq58D9U4iLh0EFV5b5GQ4GoeNa5cbuWEuhbxm4RWqAvqJkR6L4V35gln6IKvoctb6ZwXDJu5E5LSnhEkUpu9GOrMTsSyg5hJw6qWYz52ga6ngYVvyVjfrutwvoUEI+gv7UsqNiZP3s0b7W3qNG94iXgBv8/nzgju7F3ysWls+Y4NyjMZDKJa/NE6Mu+nImU2if2bsDTT1eobaXycZ3RTSlse+Itss7DXaJsvB+PY/zNZSlkwy5z1LMXqmMYnGP9W+AZbrp1rp8YXfbrbySDmX0b0Q4Q2MoQlQzpnzTwygeN0OG4emsbuf4xNrb/R6QUTAAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 100% 100%;
}
.deposit .box .right .block .inlineGroup .list .item .icon.icon-ali-pay.weixin[data-v-97997370] {
  background: url(/static/image/weixin1.png) no-repeat;
  background-size: 100% 100%;
}
.deposit .box .right .block .inlineGroup .list .item .icon[data-v-97997370] {
  margin: 0 auto 0.08rem;
  width: 0.3rem;
  height: 0.3rem;
  display: block;
}
.deposit .box .right .block .inlineGroup label[data-v-97997370] {
  display: inline-block;
  vertical-align: top;
  font-size: 0.16rem;
  color: #fff;
  margin-right: 0.25rem;
  min-width: 0.65rem;
}
.deposit .box .right .block .inlineGroup .list[data-v-97997370] {
  display: inline-block;
  vertical-align: top;
  width: 6rem;
}
.deposit .box .right .block .inlineGroup .list .item.active[data-v-97997370][data-v-39222142]{
	background-color: #fafafa;
}
.deposit .box .right .block .c .info .inputGroup input[data-v-4b991137][data-v-39222142],
.deposit .box .right .block .c .info .warningMessage[data-v-4b991137][data-v-39222142],
.deposit .box .right .block .c .formGroup .protocolList li[data-v-043ac135][data-v-39222142],{
	background: #fafafa;
	color: #ffcb4c;
	border: 1px solid #ccc;
	
}
.deposit .box .right .block .c .formGroup .protocolList li.active[data-v-043ac135][data-v-39222142]{
	border: 2px solid #d7967f;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/deposit.vue